// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n/*Prevent label line wrapping in vehicle detail page*/\n\n/*Original flex-grow is 5*/\n.field-body {\n  -webkit-box-flex: 3;\n      -ms-flex-positive: 3;\n          flex-grow: 3;\n}\n", ""]);
// Exports
module.exports = exports;
